import { render, staticRenderFns } from "./AddVendorForm2.vue?vue&type=template&id=7a5ac658&scoped=true&"
import script from "./AddVendorForm2.vue?vue&type=script&lang=js&"
export * from "./AddVendorForm2.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorForm2.vue?vue&type=style&index=0&id=7a5ac658&prod&lang=scss&scoped=true&"
import style1 from "./AddVendorForm2.vue?vue&type=style&index=1&id=7a5ac658&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ac658",
  null
  
)

export default component.exports